import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordWebVisitorV2Body } from './record-web-visitor-v2-request';
import type { IRecordWebVisitorV2Response } from './record-web-visitor-v2-response';
import { recordWebVisitorV2ResponseSchema } from './record-web-visitor-v2-response';

export async function recordWebVisitorV2Api(
  body: IRecordWebVisitorV2Body,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IRecordWebVisitorV2Response>> {
  return postRequest<IRecordWebVisitorV2Response>({
    body,
    options,
    path: '/web/visitor/v2',
    schema: recordWebVisitorV2ResponseSchema,
  });
}
